import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=08e9fba9&scoped=true&"
import script from "./UserInfo.vue?vue&type=script&lang=js&"
export * from "./UserInfo.vue?vue&type=script&lang=js&"
import style0 from "./UserInfo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UserInfo.vue?vue&type=style&index=1&id=08e9fba9&scoped=true&lang=scss&"
import style2 from "./UserInfo.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e9fba9",
  null
  
)

export default component.exports